<template>

<app-item route="Template" :id="item.id" id-name="template" :selected="selected" v-on:shiftclick="$emit('shiftclick')">

	<app-item-title :text="$highlight(item.name, highlight)" />

	<app-item-count route="Text" :params="{id: item.id}" tooltip="Groups and locations using this template" :count="groupCount" />

</app-item>

</template>

<script>

export default {

	props: ['item', 'highlight', 'selected'],

	computed: {

		groupCount: function() {

			return this.$_.where(this.$store.getters['groups'], {
				template: this.item.id
			}).length + this.$_.where(this.$store.getters['locations'], {
				template: this.item.id
			}).length

		}

	}

}

</script>

<style scoped>

</style>
